<svelte:body on:item={put_item} />
<script>
    import _ from 'lodash';
    import {validate_int} from '../../../validators.js';
    import {parameter, network} from '../../../stores.js';
    import {createEventDispatcher} from 'svelte';
    import {precision} from '../../../config.js';
    import RalColor from "../../parts/RalColor.svelte";

    const dispatch = createEventDispatcher();
    const fixprecision = (value) => Math.ceil(value * precision) / precision;

    export let calc;
    export let options;

    export let put_item = async (e) => {
        let item = e.detail;

        if (item) {
            let title = item.title.split(', ', 6);

            width.set(title[1].split('x')[0]);
            height.set(title[1].split('x')[1]);
            col.set(title[2]);
            otkr = otkrivanie.find((el) => item.title.toLowerCase().includes(el.toLowerCase()));

            upak= title[5];
            count= (+item.quantity);
            comment= item.comment;
            fetchData = await fetch();
            change();
        }
    };

    const otkrivanie = [
        'Створка горизонт',
        'Створка вертикал'
    ];

    const color = options.color || {
        'Белый': 'Белый',
        'Коричневый': 'Коричневый',
        'Антрацит': 'Антрацит',
        'Неокрас': 'Неокрас',
        'Цветной': 'Цветной',
    };

    const polotna = {
        'Плиссе 16 мм Стандарт': 'Плиссе 16 мм Стандарт',
        'Плиссе 16 мм Антипыль': 'Плиссе 16 мм Антипыль',
        'Плиссе 16 мм Антикот': 'Плиссе 16 мм Антикот',
        'Ткань сотовая 16 мм': 'Ткань сотовая 16 мм',
    };

    const fetch = async () => {
        let result = await network.fetch_data('Плиссе вставная', '', '');
               return {
            name: _.groupBy(result, 'name'),
            ind1: _.groupBy(result, 'ind1'),
            ind2: _.groupBy(result, 'ind2'),
            ind3: _.groupBy(result, 'ind3'),
            edIzmer: _.groupBy(result, 'edIzmer'),
            result,
        }
    }

    let
        width = parameter('width', '1000'),
        height = parameter('height', '2000'),
        col = parameter('color', 'Белый'), // цвет
        otkr = 'Створка горизонт', // открывание
        polotno = 'Плиссе 16 мм Стандарт',
        upak = 'стрейч',
        comment ='',
        count = 1
    ;

    let fetchData = fetch();

    let
        montage_item,
        montage_price = 1;

    // расчёт стоимости
    const change = _.debounce(async () => {
        let data = await fetchData;

        let
            quantity = +count,

            w = +$width,
            h = +$height
        ;

        let result = {
            type: 'Вставная Плиссе',
            name: 'Вставная Плиссе',
            subname: [
                $width + 'x' + $height, ', ',
                $col, ', ', polotno, ', ', otkr, ', ',  upak
            ].join(''),
            title: [
                'Вставная Плиссе', ', ', $width + 'x' + $height, ', ',
                $col, ', ', polotno, ', ', otkr, ', ',  upak
            ].join(''),
            params: {
                ind1: polotno +', ' + upak,
                ind2: $col,
                ind3: otkr,
                ind4: $width,
                ind5: $height,
            },
            price: {rozn: 0, opt: 0, sebest: 0,},
            quantity,
            materials: {},
            comment: comment,
            vStrukture: options.vStrukture || 37
        };

        _.forEach(data.result, function (item) {
            let name = item.name.toLowerCase();

            let price = {rozn: 0, opt: 0, sebest: 0}
            let kolvo = 0;

            if (name.includes('профиль рамы') && item.ind2 == $col) {
                switch (otkr) {
                    case 'Створка горизонт':
                        kolvo = (((w - 37) * 2 + (h - 59) * 2) / 1000).toFixed(3);
                        break;

                    case 'Створка вертикал':
                        kolvo = (((w - 57) * 2 + (h - 39) * 2) / 1000).toFixed(3);
                        break;
                }
            }
            if (name.includes('профиль створки') &&  item.ind2 == $col) {
                switch (otkr) {
                    case 'Створка горизонт':
                        kolvo = ((h - 66) / 1000).toFixed(3);
                        break;

                    case 'Створка вертикал':
                        kolvo = ((w - 62) / 1000).toFixed(3);
                        break;
                }
            }
            if (name.includes(polotno.toLowerCase())) {
                let wave;

                switch (otkr) {
                    case 'Створка горизонт':
                        wave = Math.ceil(w/ 1000 / 20);
                        kolvo = ((h - 37) / 1000 * wave).toFixed(3);
                        break;

                    default:  //Створка вертикал
                        wave = Math.ceil(h/ 1000 / 20);
                        kolvo = ((w - 37) / 1000 * wave ).toFixed(3);
                        break;
                }
            }


            if (name.includes('вставка')) {
              switch (otkr) {
                    case 'Створка горизонт':
                        kolvo = ((h - 37) / 1000 * 2).toFixed(3);
                        break;

                    default:  //'Створка вертикал
                        kolvo = ((w - 37) / 1000 * 2).toFixed(3);
                        break;
                }
            }
            let c, k;

            if (name.includes('нить')) {
                switch (otkr) {
                    case 'Створка горизонт':

                        switch (true) {
                            case (w <= 1500): {
                                c = 4;
                                break;
                            }
                            default: {
                                c = 6;
                                break;
                            }
                        }
                        kolvo = ((w +100) / 1000 * c).toFixed(3);

                        break;

                    default:  //'Створка вертикал
                        switch (true) {
                            case (h <= 1500): {
                                c = 4;
                                break;
                            }
                            case (h <= 2500): {
                                c = 6;
                                break;
                            }
                            default: {
                                c = 8;
                                break;
                            }
                        }
                        kolvo = (( h +100) / 1000 * c).toFixed(3);
                        break;
                }


            }
            if (name.includes('гвозд')) {
                kolvo = 4;
            }

            if (name.includes(upak) ) {
                kolvo = 1;
            }



            if (name.includes('пятка')) {
                kolvo = (2).toFixed(3);
            }
            if (name.includes('угол стандарт')) {
                kolvo = (4).toFixed(3);
            }

            if (name.includes('нитенаправлятель') || name.includes('нитедержатель')
                || name.includes('крышка декор')
               ) {
                kolvo = 4;
            }



            if (name.includes('работа')) {
                kolvo = 1;
            }


            if (name.includes('саморез')) {
                let c, k;
                switch (otkr) {
                    case 'Створка горизонт':
                        k = h - 8;

                  /*  case 'Створка горизонт':
                        kolvo = ((h - 66) / 1000).toFixed(3);
                        break;

                    case 'Створка вертикал':
                        kolvo = ((w - 62) / 1000).toFixed(3);
                        break;*/

                        switch (true) {
                            case (h - 66) < 1500: {
                                c = 5;
                                break;
                            }

                            default: {
                                c = 11;
                                break;
                            }
                        }
                        break;

                    default:  //'Створка вертикал
                        k = w - 8;

                        switch (true) {
                            case (w - 62) < 1500: {
                                c = 5;
                                break;
                            }
                            default: {
                                c = 11;
                                break;
                            }
                        }
                        break;
                }
                kolvo = c ;
            }

            if (kolvo) {
                price['rozn'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.price);
                price['opt'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.opt_price);
                price['sebest'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.sebestomost);

                result.materials[item.name] = {
                    order: +item.poryadok,
                    id: item.idTovar,
                    spis: item.procentSpisania,
                    type: item.edIzmer,
                    oprice: {
                        rozn: (+item.price).toFixed(2),
                        opt: (+item.opt_price).toFixed(2),
                        sebest: (+item.sebestomost).toFixed(2),
                    },
                    price,
                    quantity,
                    count: (+kolvo).toFixed(3)
                };
            }
            if (name.includes('монтаж')) {
                montage_item = item;
            }

        }, 250);

        result.price.rozn = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'rozn').toFixed(2);
        result.price.opt = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'opt').toFixed(2);
        result.price.sebest = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'sebest').toFixed(2);

        if(montage_item === undefined){
            console.log('montage_item не определён');
        }else{
            let mprice = Math.round((result.price.rozn / quantity) / 100 * montage_item.procentSpisania / 100) * 100;
            montage_price = +(montage_item.opt_price > mprice ? montage_item.opt_price * quantity : mprice * quantity).toFixed(2);

            dispatch('mounting', {item: montage_item, price: montage_price});
        }

        dispatch('item', result);
    });

    change();
</script>

{#await fetchData}
    <div class="card-body">
        <div class="text-center">
            <p>Загрузка..</p>
        </div>
    </div>
{:then data}
    <!--<pre>{JSON.stringify(data, null, 4)}</pre>-->
    <div class="card-body" on:keyup={change} on:paste={change} on:change={change}>
        <div class="row d-flex">
            <div class="col-12 col-sm-7 ">
                <div class="row">
                    <div class="col-12">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Направление</label>
                                <select class="form-control form-select" bind:value={otkr}>
                                    {#each otkrivanie as item}
                                        <option value="{item}" >{item}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Цвет</label>
                                <select class="form-control form-select" bind:value={$col} on:change={() => {change()}}>
                                    {#each Object.entries(color) as [value]}
                                        <option value="{value}">{value}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Тип полотна</label>
                                <select class="form-control form-select" bind:value={polotno} on:change={() => {change()}}>
                                    {#each Object.entries(polotna) as [value]}
                                        <option value="{value}">{value}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">

                    <div class="col-12">
                        <span class="text-danger">Размеры светового проема</span>
                    </div>
                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">300 ≥ Ширина, мм ≥ 1000</label>
                                <input type="number" class="form-control" step="10" min="300" max="{ options.max && options.max.width ? options.max.width : 1000 }" bind:value={$width} use:validate_int={$width}>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">300 ≥ Высота, мм ≥ 2200</label>
                                <input type="number" class="form-control" step="10" min="300" max="{ options.max && options.max.height ? options.max.height : 2200 }" bind:value={$height} use:validate_int={$height}>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Упаковка</label>
                                <select class="form-control form-select" bind:value={upak}>
                                    <option value="стрейч">стрейч</option>
                                    <option value="картон">картон</option>
                                    <option value="без упаковки">без упаковки</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>



            </div>



            <div class="col-12 col-sm-5 text-center d-flex order-last  order-sm-first justify-content-around">
                <img style="max-height: 250px" class="img-fluid  p-3" src="/img/plisse/ind3/{otkr.toLowerCase().replaceAll(' ', '-')}-{$col.toLowerCase()}.jpg"/>
            </div>
        </div>

        <div class="row">

          <!--  <RalColor color={$col} bind:comment={comment}/>-->
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <div class="input-wrapper">
                            <label class="form-label">Примечание</label>
                            <textarea class="form-control" bind:value={comment}></textarea>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Количество</label>
                        <input type="number" class="form-control text-center" min="1" bind:value={count}>
                    </div>
                </div>
            </div>


        </div>

    </div>
{/await}

<div id="toast-ind1" class="toast-box toast-top bg-danger">
    <div class="in">
        <div class="text">
            При высоте больше 1400 мм рекомендуется поставить перемычку
        </div>
    </div>
</div>
